<template>
  <div class="form-buttons">
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
.form-buttons {
  margin-top: 10px;

  & > * {
    margin-left: 5px;

    &:first-child {
      margin-left: 0px;
    }
  }
}
</style>